import { IconVariant } from '@/components/icons/types';
import { ReactNode } from 'react';

export type UseMegaMenuManagerProps = {
  tabs?: TabItem[];
  navigationContainerId?: string;
};

export type UseMegaMenuManagerOutput = {
  navRef: React.RefObject<HTMLElement>;
  navigationContainerRef: React.RefObject<HTMLDivElement>;
  navigationContainerId: string;
  tabs: TabItem[];
  activeTab?: TabIdentifier;
  activeSubcategory?: TabIdentifier;
  renderNavigationContainer: (props: UseMegaMenuManagerOutput) => ReactNode;
  onNavigationOpen: (identifier: TabIdentifier) => void;
  onSubCategoryNavigationOpen: (identifier: TabIdentifier) => void;
  onSubCategoryNavigationLeave: () => void;
  onNavigationLeave: (blockTabHover?: TabIdentifier) => void;
  onMouseEnter: (identifier: TabIdentifier) => void;
  onMouseLeave: () => void;
};

export enum TabIdentifier {
  Categories = 'categories',
  Hairdresser = 'hairdresser',
  Massage = 'massage',
  Nails = 'nails',
  Lashes = 'lashes',
  Skincare = 'skincare',
  Beauty = 'beauty',
  Health = 'health',
  More = 'more',
  Giftcard = 'giftcard',
  Wellnesscard = 'wellnesscard',
  SistaMinuten = 'sista_minuten',
}

export type TabItem = {
  icon?: IconVariant;
  label: string;
  to?: string;
  className?: string;
  identifier: TabIdentifier;
  breakpoint?: string;
};

export type MegaMenuCategory = {
  identifier: TabIdentifier;
  categories: {
    title: string;
    icon: IconVariant;
    links: { label: string; to: string }[];
  }[];
};
